export class GrnItemIdReq{
  grnItemId:number
  constructor(
    grnItemId:number,
  ){
    this.grnItemId = grnItemId
  }


}
